<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <card>
                    <template slot="header">
                        <h3 class="card-title">Podešavanja šablona</h3>
                    </template>

                    <!-- TABOVI -->
                    <el-tabs v-model="activeTab" type="border-card">
                        <!-- TAB 1: TICKET TEMPLATE -->
                        <el-tab-pane label="Doplatna karta" name="ticket">
                            <div class="row">
                                <div class="col-md-8">
                                    <h4>Šablon za štampanje</h4>
                                    <textarea class="form-control ticket-textarea" v-model="ticket" 
                                        placeholder="Unesite šablon za štampanje..."></textarea>
                                    <base-button type="success" class="mt-3" @click="savePrintTicket()">
                                        <i class="tim-icons icon-check-2"></i> Sačuvaj šablon
                                    </base-button>
                                </div>
                                <div class="col-md-4">
                                    <div class="info-panel">
                                        <h4><i class="tim-icons icon-bulb-63"></i> Placeholder-i</h4>
                                        <table class="placeholder-table">
                                            <tr><td><code>{plates}</code></td><td>Registarske oznake</td></tr>
                                            <tr><td><code>{zone}</code></td><td>Zona parkiranja</td></tr>
                                            <tr><td><code>{date}</code></td><td>Datum izdavanja</td></tr>
                                            <tr><td><code>{ticketNumber}</code></td><td>Broj naloga</td></tr>
                                            <tr><td><code>{amount}</code></td><td>Iznos (EUR)</td></tr>
                                        </table>
                                        <hr>
                                        <p style="color: white;"><i class="tim-icons icon-alert-circle-exc"></i> 
                                            Znak <code>^</code> na početku reda znači da će tu biti uvećani font</p>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>

                        <!-- TAB 2: SMS TEMPLATES -->
                        <el-tab-pane label="SMS šabloni" name="sms">
                            <div class="row">
                                <div class="col-md-8">
                                    <el-collapse v-model="activeSmsPanel" accordion>
                                        <el-collapse-item v-for="template in smsTemplates" :key="template.id" :name="template.id">
                                            <template slot="title">
                                                <span class="collapse-title">
                                                    <i :class="getSmsIcon(template.sms)"></i>
                                                    {{ getSmsTitle(template.sms) }}
                                                </span>
                                            </template>
                                            <p class="text-muted">{{ getSmsDescription(template.sms) }}</p>
                                            <textarea class="form-control sms-textarea" v-model="template.text"></textarea>
                                        </el-collapse-item>
                                    </el-collapse>
                                    <base-button type="success" class="mt-3" @click="saveSmsTemplates()">
                                        <i class="tim-icons icon-check-2"></i> Sačuvaj SMS šablone
                                    </base-button>
                                </div>
                                <div class="col-md-4">
                                    <div class="info-panel">
                                        <h4><i class="tim-icons icon-bulb-63"></i> SMS Placeholder-i</h4>
                                        <table class="placeholder-table">
                                            <tr><td><code>{plates}</code></td><td>Tablice</td></tr>
                                            <tr><td><code>{zone}</code></td><td>Zona</td></tr>
                                            <tr><td><code>{ticketNumber}</code></td><td>Broj karte</td></tr>
                                            <tr><td><code>{price}</code></td><td>Cena (EUR)</td></tr>
                                            <tr><td><code>{dateEnd}</code></td><td>Datum isteka</td></tr>
                                            <tr><td><code>{timeEnd}</code></td><td>Vreme isteka</td></tr>
                                            <tr><td><code>{ticketEnd}</code></td><td>Istek doplatne</td></tr>
                                            <tr><td><code>{stamp}</code></td><td>Datum izdavanja</td></tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>

                        <!-- TAB 3: EMAIL SETTINGS -->
                        <el-tab-pane label="Email server" name="email">
                            <div class="row">
                                <div class="col-md-8">
                                    <!-- Tip email servera -->
                                    <div class="form-group">
                                        <label>Tip email servera</label>
                                        <el-radio-group v-model="emailSettings.emailType" class="email-radio-group">
                                            <el-radio label="smtp">SMTP</el-radio>
                                            <el-radio label="msgraph">Microsoft 365 (Graph API)</el-radio>
                                        </el-radio-group>
                                    </div>

                                    <hr class="email-divider">

                                    <!-- Zajednička polja -->
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Email pošiljaoca</label>
                                                <input type="text" class="form-control" v-model="emailSettings.fromEmail" 
                                                    placeholder="info@firma.com">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Ime pošiljaoca</label>
                                                <input type="text" class="form-control" v-model="emailSettings.fromName" 
                                                    placeholder="Parking Servis">
                                            </div>
                                        </div>
                                    </div>

                                    <hr class="email-divider">

                                    <!-- SMTP polja -->
                                    <div v-if="emailSettings.emailType === 'smtp'">
                                        <h5 class="email-section-title">SMTP podešavanja</h5>
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class="form-group">
                                                    <label>SMTP Host</label>
                                                    <input type="text" class="form-control" v-model="emailSettings.smtpHost" 
                                                        placeholder="smtp.gmail.com">
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Port</label>
                                                    <input type="number" class="form-control" v-model.number="emailSettings.smtpPort" 
                                                        placeholder="587">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Korisničko ime</label>
                                                    <input type="text" class="form-control" v-model="emailSettings.smtpUsername" 
                                                        placeholder="user@gmail.com">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Lozinka</label>
                                                    <input type="password" class="form-control" v-model="emailSettings.smtpPassword" 
                                                        placeholder="••••••••">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <el-checkbox v-model="emailSettings.smtpSsl" class="email-checkbox">SSL (port 465)</el-checkbox>
                                            </div>
                                            <div class="col-md-6">
                                                <el-checkbox v-model="emailSettings.smtpStarttls" class="email-checkbox">STARTTLS (port 587)</el-checkbox>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- MS Graph polja -->
                                    <div v-if="emailSettings.emailType === 'msgraph'">
                                        <h5 class="email-section-title">Microsoft 365 podešavanja</h5>
                                        <div class="form-group">
                                            <label>Tenant ID</label>
                                            <input type="text" class="form-control" v-model="emailSettings.msTenantId" 
                                                placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx">
                                        </div>
                                        <div class="form-group">
                                            <label>Client ID</label>
                                            <input type="text" class="form-control" v-model="emailSettings.msClientId" 
                                                placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx">
                                        </div>
                                        <div class="form-group">
                                            <label>Client Secret</label>
                                            <input type="password" class="form-control" v-model="emailSettings.msClientSecret" 
                                                placeholder="••••••••">
                                        </div>
                                    </div>

                                    <hr class="email-divider">

                                    <!-- Dugmad -->
                                    <div class="email-actions">
                                        <base-button type="success" @click="saveEmailSettings()">
                                            <i class="tim-icons icon-check-2"></i> Sačuvaj
                                        </base-button>
                                        <base-button type="info" @click="showTestModal = true" style="margin-left: 10px;">
                                            <i class="tim-icons icon-email-85"></i> Pošalji test email
                                        </base-button>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="info-panel">
                                        <h4><i class="tim-icons icon-bulb-63"></i> Pomoć</h4>
                                        <div v-if="emailSettings.emailType === 'smtp'">
                                            <p style="color: #ccc;">Unesite podatke vašeg SMTP servera. Za Gmail koristite:</p>
                                            <table class="placeholder-table">
                                                <tr><td><code>Host</code></td><td>smtp.gmail.com</td></tr>
                                                <tr><td><code>Port</code></td><td>587</td></tr>
                                                <tr><td><code>STARTTLS</code></td><td>Da</td></tr>
                                            </table>
                                        </div>
                                        <div v-if="emailSettings.emailType === 'msgraph'">
                                            <p style="color: #ccc;">Za Microsoft 365 potrebno je registrovati aplikaciju na Entra ID portalu.</p>
                                            <table class="placeholder-table">
                                                <tr><td><code>Tenant ID</code></td><td>Entra ID → Overview</td></tr>
                                                <tr><td><code>Client ID</code></td><td>App registrations → vaša app</td></tr>
                                                <tr><td><code>Secret</code></td><td>Certificates & secrets</td></tr>
                                            </table>
                                            <hr>
                                            <p style="color: #ccc;"><i class="tim-icons icon-alert-circle-exc"></i> 
                                                Email pošiljaoca mora biti korisnik u Microsoft 365 organizaciji</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Test email modal -->
                            <el-dialog title="Pošalji test email" :visible.sync="showTestModal" width="400px" class="test-email-dialog">
                                <div class="form-group">
                                    <label>Email adresa za test</label>
                                    <input type="text" class="form-control" v-model="testEmailAddress" 
                                        placeholder="test@example.com">
                                </div>
                                <span slot="footer" class="dialog-footer">
                                    <base-button type="default" @click="showTestModal = false">Otkaži</base-button>
                                    <base-button type="success" @click="sendTestEmail()">Pošalji</base-button>
                                </span>
                            </el-dialog>
                        </el-tab-pane>

                        <!-- TAB 4: PODACI O PLAĆANJU (mobilna app) -->
                        <el-tab-pane label="Podaci za mobilnu APP" name="paymentInfo">
                            <el-radio-group v-model="paymentInfoLang" class="email-radio-group">
                                <el-radio label="mn">Crnogorski (mn)</el-radio>
                                <el-radio label="en">Engleski (en)</el-radio>
                            </el-radio-group>

                            <hr class="email-divider">

                            <div class="row">
                                <!-- Editor (levo) -->
                                <div class="col-md-6">
                                    <h5 class="email-section-title">
                                        HTML sadržaj ({{ paymentInfoLang }})
                                    </h5>
                                    <textarea v-if="paymentInfoLang === 'mn'" class="form-control payment-textarea"
                                        v-model="paymentInfoMn"
                                        placeholder="<section><h2>1. Podaci o prodajnom mjestu</h2>...</section>"></textarea>
                                    <textarea v-else class="form-control payment-textarea"
                                        v-model="paymentInfoEn"
                                        placeholder="<section><h2>1. Point of sale information</h2>...</section>"></textarea>
                                </div>

                                <!-- Pregled (desno) -->
                                <div class="col-md-6">
                                    <h5 class="email-section-title">Pregled</h5>
                                    <iframe class="payment-preview" :srcdoc="paymentInfoLang === 'mn' ? paymentInfoMn : paymentInfoEn"></iframe>
                                </div>
                            </div>

                            <base-button type="success" class="mt-3" @click="savePaymentInfos()">
                                <i class="tim-icons icon-check-2"></i> Sačuvaj
                            </base-button>
                        </el-tab-pane>

                        <!-- TAB: TIKETI (NOTIFIKACIJE) -->
                        <el-tab-pane label="Tiketi (notifikacije)" name="ticketNotify">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group">
                                        <label>Mejlovi za notifikacije</label>
                                        <textarea class="form-control sms-textarea" v-model="ticketNotifyEmails"
                                            placeholder="mejl1@firma.com, mejl2@firma.com (ili svaki u novom redu)"></textarea>
                                    </div>
                                    <base-button type="success" class="mt-3" @click="saveTicketSettings()">
                                        <i class="tim-icons icon-check-2"></i> Sačuvaj
                                    </base-button>
                                </div>
                                <div class="col-md-4">
                                    <div class="info-panel">
                                        <h4><i class="tim-icons icon-bulb-63"></i> Pomoć</h4>
                                        <p style="color:#ccc;">Na ove adrese stiže notifikacija kad se kreira tiket,
                                            doda odgovor ili promeni status.</p>
                                        <p style="color:#ccc;">Više adresa razdvoji zarezom ili novim redom.
                                            Prva ide kao primalac, ostale u kopiju (CC).</p>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/util/axiosinstance';
import { Tabs, TabPane, Collapse, CollapseItem, RadioGroup, Radio, Checkbox, Dialog } from 'element-ui';

export default {
    components: {
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Checkbox.name]: Checkbox,
        [Dialog.name]: Dialog
    },
    data() {
        return {
            url: 'https://budva.scancar.org:8443/kuca',
            loading: false,
            ticket: '',
            smsTemplates: [],
            activeTab: 'ticket',
            activeSmsPanel: '',
            emailSettings: {
                id: null,
                emailType: 'smtp',
                fromEmail: '',
                fromName: '',
                smtpHost: '',
                smtpPort: 587,
                smtpUsername: '',
                smtpPassword: '',
                smtpSsl: false,
                smtpStarttls: true,
                msTenantId: '',
                msClientId: '',
                msClientSecret: ''
            },
            showTestModal: false,
            testEmailAddress: '',
            paymentInfoLang: 'mn',
            paymentInfoMn: '',
            paymentInfoEn: '',
            ticketNotifyEmails: ''
        };
    },
    methods: {
        getSmsIcon(smsType) {
            const icons = {
                'newSms': 'tim-icons icon-check-2',
                'reminder': 'tim-icons icon-bell-55',
                'paymentError': 'tim-icons icon-alert-circle-exc',
                'wrongFormat': 'tim-icons icon-simple-remove',
                'rentTicket': 'tim-icons icon-badge',
                'smsTicketExist': 'tim-icons icon-paper',
                'cantExtend': 'tim-icons icon-lock-circle'
            };
            return icons[smsType] || 'tim-icons icon-chat-33';
        },
        getSmsTitle(smsType) {
            const titles = {
                'newSms': 'Potvrda kupovine karte',
                'reminder': 'Podsetnik pre isteka',
                'paymentError': 'Greška pri plaćanju',
                'wrongFormat': 'Pogrešan format tablica',
                'rentTicket': 'Obaveštenje o doplatnoj karti',
                'smsTicketExist': 'Doplatna karta već postoji',
                'cantExtend': 'Dostignut limit plaćanja'
            };
            return titles[smsType] || smsType;
        },
        getSmsDescription(smsType) {
            const descriptions = {
                'newSms': 'Šalje se korisniku nakon uspešne kupovine parking karte putem SMS-a.',
                'reminder': 'Šalje se korisniku kao podsetnik pre isteka vremena parkiranja.',
                'paymentError': 'Šalje se kada plaćanje nije uspelo.',
                'wrongFormat': 'Šalje se kada korisnik pošalje tablice u pogrešnom formatu.',
                'rentTicket': 'Šalje se vlasniku vozila kada kontrolor izda doplatnu kartu.',
                'smsTicketExist': 'Šalje se kada za vozilo već postoji aktivna doplatna karta.',
                'cantExtend': 'Šalje se kada korisnik pokuša produžiti parking ali je dostigao dnevni limit.'
            };
            return descriptions[smsType] || '';
        },
        getPrintTicket() {
            this.loading = true;
            axios.get(this.url + '/settings/getPrintTicket').then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.ticket = result.data.ticket || '';
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom učitavanja',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        savePrintTicket() {
            this.loading = true;
            const body = {
                text: this.ticket
            };
            axios.post(this.url + '/settings/savePrintTicket', body).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.$notify({
                        message: 'Šablon za štampanje uspešno sačuvan',
                        timeout: 3000,
                        icon: 'tim-icons icon-check-2',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom čuvanja',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        getSmsTemplates() {
            this.loading = true;
            axios.get(this.url + '/settings/getSmsTemplates').then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.smsTemplates = result.data.smsTemplates || [];
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom učitavanja',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        saveSmsTemplates() {
            this.loading = true;
            const body = {
                smsTemplates: this.smsTemplates
            };
            axios.post(this.url + '/settings/saveSmsTemplates', body).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.$notify({
                        message: 'SMS šabloni uspešno sačuvani',
                        timeout: 3000,
                        icon: 'tim-icons icon-check-2',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom čuvanja',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        getEmailSettings() {
            axios.get(this.url + '/settings/getEmailSettings').then(result => {
                if (result.data.result === 'ok' && result.data.email) {
                    let em = result.data.email;
                    this.emailSettings.id = em.id || null;
                    this.emailSettings.emailType = em.emailType || 'smtp';
                    this.emailSettings.fromEmail = em.fromEmail || '';
                    this.emailSettings.fromName = em.fromName || '';
                    this.emailSettings.smtpHost = em.smtpHost || '';
                    this.emailSettings.smtpPort = em.smtpPort || 587;
                    this.emailSettings.smtpUsername = em.smtpUsername || '';
                    this.emailSettings.smtpPassword = em.smtpPassword || '';
                    this.emailSettings.smtpSsl = em.smtpSsl || false;
                    this.emailSettings.smtpStarttls = em.smtpStarttls || false;
                    this.emailSettings.msTenantId = em.msTenantId || '';
                    this.emailSettings.msClientId = em.msClientId || '';
                    this.emailSettings.msClientSecret = em.msClientSecret || '';
                }
            });
        },
        saveEmailSettings() {
            this.loading = true;
            axios.post(this.url + '/settings/saveEmailSettings', this.emailSettings).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.$notify({
                        message: 'Email podešavanja uspešno sačuvana',
                        timeout: 3000,
                        icon: 'tim-icons icon-check-2',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getEmailSettings();
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom čuvanja',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        sendTestEmail() {
            if (!this.testEmailAddress) {
                this.$notify({
                    message: 'Unesite email adresu',
                    timeout: 3000,
                    icon: 'tim-icons icon-bell-55',
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: 'warning'
                });
                return;
            }
            this.loading = true;
            this.showTestModal = false;
            axios.post(this.url + '/settings/testEmail', { to: this.testEmailAddress }).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.$notify({
                        message: 'Test email uspešno poslat na ' + this.testEmailAddress,
                        timeout: 5000,
                        icon: 'tim-icons icon-check-2',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom slanja',
                        timeout: 5000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        getPaymentInfos() {
            this.loading = true;
            axios.get(this.url + '/paymentInfo/getPaymentInfos').then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.paymentInfoMn = result.data.mn || '';
                    this.paymentInfoEn = result.data.en || '';
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom učitavanja',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        savePaymentInfos() {
            this.loading = true;
            const body = {
                mn: this.paymentInfoMn,
                en: this.paymentInfoEn
            };
            axios.post(this.url + '/paymentInfo/savePaymentInfos', body).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.$notify({
                        message: 'Podaci o plaćanju sačuvani',
                        timeout: 3000,
                        icon: 'tim-icons icon-check-2',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom čuvanja',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        getTicketSettings() {
            axios.get(this.url + '/supportTicket/getTicketSettings').then(result => {
                if (result.data.result === 'ok') {
                    this.ticketNotifyEmails = result.data.notifyEmails || '';
                }
            });
        },
        saveTicketSettings() {
            this.loading = true;
            axios.post(this.url + '/supportTicket/saveTicketSettings', { notifyEmails: this.ticketNotifyEmails }).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.$notify({
                        message: 'Mejlovi za notifikacije sačuvani',
                        timeout: 3000,
                        icon: 'tim-icons icon-check-2',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom čuvanja',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        }
    },
    mounted() {
        this.getPrintTicket();
        this.getSmsTemplates();
        this.getEmailSettings();
        this.getPaymentInfos();
        this.getTicketSettings();
    }
};
</script>

<style scoped>
/* Textarea styling */
.ticket-textarea {
    width: 100%;
    min-height: 500px !important;
    height: 500px !important;
    background-color: #1e1e2d !important;
    border: 1px solid #2b3553 !important;
    color: #fff !important;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    padding: 15px;
    border-radius: 5px;
    resize: vertical !important;
}

.sms-textarea {
    width: 100%;
    min-height: 120px !important;
    height: 120px !important;
    background-color: #1e1e2d !important;
    border: 1px solid #2b3553 !important;
    color: #fff !important;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    padding: 10px;
    border-radius: 5px;
    resize: vertical !important;
    margin-top: 10px;
}

.ticket-textarea:focus,
.sms-textarea:focus {
    border-color: #e14eca !important;
    outline: none;
}

/* Payment info preview */
.payment-textarea {
    width: 100%;
    min-height: 620px !important;
    height: 620px !important;
    background-color: #1e1e2d !important;
    border: 1px solid #2b3553 !important;
    color: #fff !important;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    padding: 15px;
    border-radius: 5px;
    resize: vertical !important;
}

.payment-textarea:focus {
    border-color: #e14eca !important;
    outline: none;
}

.payment-preview {
    width: 100%;
    height: 620px;
    border: 1px solid #2b3553;
    border-radius: 5px;
    background: #ffffff;
}

/* Info panel */
.info-panel {
    background-color: rgba(30, 136, 229, 0.1);
    border: 1px solid rgba(30, 136, 229, 0.3);
    border-radius: 5px;
    padding: 20px;
    height: 100%;
}

.info-panel h4 {
    color: #1e88e5;
    margin-bottom: 15px;
    font-size: 16px;
}

.info-panel h4 i {
    margin-right: 8px;
}

.placeholder-table {
    width: 100%;
    font-size: 13px;
    color: #fff;
}

.placeholder-table td {
    padding: 5px 0;
    vertical-align: top;
    color: #fff;
}

.placeholder-table td:first-child {
    width: 120px;
}

.placeholder-table code {
    background-color: rgba(0, 0, 0, 0.3);
    padding: 2px 6px;
    border-radius: 3px;
    color: #e14eca;
    font-size: 12px;
}

/* Collapse styling */
.collapse-title {
    font-size: 15px;
    color: #fff;
}

.collapse-title i {
    margin-right: 10px;
    color: #e14eca;
}

/* Email settings */
.email-radio-group {
    display: block;
    margin-top: 8px;
}

.email-divider {
    border-color: #2b3553;
    margin: 20px 0;
}

.email-section-title {
    color: #e14eca;
    margin-bottom: 15px;
    font-size: 15px;
}

.email-checkbox {
    color: #fff !important;
    margin-top: 10px;
}

.email-actions {
    display: flex;
    align-items: center;
}

/* Loader */
.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
}

.loader {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>

<!-- Element UI overrides - must be unscoped -->
<style>
.el-tabs--border-card {
    background-color: #27293d !important;
    border-color: #2b3553 !important;
    box-shadow: none !important;
}

.el-tabs--border-card > .el-tabs__header {
    background-color: #1e1e2d !important;
    border-bottom-color: #2b3553 !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item {
    color: #9a9a9a !important;
    border-color: #2b3553 !important;
    background-color: transparent !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    color: #fff !important;
    background-color: #27293d !important;
    border-color: #2b3553 !important;
    border-bottom-color: #27293d !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
    color: #e14eca !important;
}

.el-tabs__content {
    padding: 20px !important;
    background-color: #27293d !important;
}

.el-collapse {
    border: none !important;
    border-top: 1px solid #2b3553 !important;
    border-bottom: 1px solid #2b3553 !important;
}

.el-collapse-item__header {
    background-color: #1e1e2d !important;
    border-color: #2b3553 !important;
    border-bottom: 1px solid #2b3553 !important;
    color: #fff !important;
    padding: 0 15px !important;
    height: 50px !important;
    line-height: 50px !important;
    font-size: 14px !important;
}

.el-collapse-item__header:hover {
    background-color: #27293d !important;
}

.el-collapse-item__header .el-collapse-item__arrow {
    color: #e14eca !important;
}

.el-collapse-item__wrap {
    background-color: #27293d !important;
    border-color: #2b3553 !important;
    border-bottom: 1px solid #2b3553 !important;
}

.el-collapse-item__content {
    padding: 15px !important;
    color: #9a9a9a !important;
    background-color: #27293d !important;
}

/* Radio group dark theme */
.email-radio-group .el-radio__label {
    color: #fff !important;
}

.email-radio-group .el-radio__input.is-checked .el-radio__inner {
    border-color: #e14eca !important;
    background: #e14eca !important;
}

.email-radio-group .el-radio__input.is-checked + .el-radio__label {
    color: #e14eca !important;
}

/* Checkbox dark theme */
.email-checkbox .el-checkbox__label {
    color: #fff !important;
}

.email-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #e14eca !important;
    border-color: #e14eca !important;
}

/* Dialog dark theme */
.test-email-dialog .el-dialog {
    background-color: #27293d !important;
}

.test-email-dialog .el-dialog__header {
    border-bottom: 1px solid #2b3553;
}

.test-email-dialog .el-dialog__title {
    color: #fff !important;
}

.test-email-dialog .el-dialog__body {
    padding: 20px !important;
}

.test-email-dialog .el-dialog__footer {
    border-top: 1px solid #2b3553;
}
</style>